exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#vision .row[_v-4024155a]{max-width:100%}#vision .content[_v-4024155a]{background-color:#f0f0f2;padding:5rem 4rem 3.5rem}@media screen and (max-width:63.9375em){#vision .content[_v-4024155a]{padding:2.5rem .75rem 3.5rem;text-align:center}}#vision .photo[_v-4024155a]{margin-left:-5rem}#vision .photo img[_v-4024155a]{box-shadow:0 0 .3rem rgba(0,0,0,.3);border:.06rem solid hsla(0,0%,70%,.73);width:17.8rem;margin-top:6rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-4024155a&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Vision.vue
 ** module id = 31
 ** module chunks = 1
 **/